// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".approval-search-advanced-modal .ivu-date-picker,.approval-search-advanced-modal .ivu-input-number,.approval-search-advanced-modal .ivu-input-wrapper,.approval-search-advanced-modal .ivu-radio-group,.approval-search-advanced-modal .ivu-select,.approval-search-advanced-modal .ivu-select .ivu-select-dropdown{width:100%}.approval-search-advanced-modal .range-row .ivu-form-item{width:48%}", ""]);
// Exports
module.exports = exports;
